export default __webpack_public_path__ + "static/media/parking-lot-fill.7a8b06ed.svg";